module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Matteo-jongen-koperfolie-foliedruk-digitaal-drukwerk-doopsuiker-3.3d599a60.jpg";